"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function busquedaRango(min, max, valor) {
    if (min == null && max == null)
        return true;
    if (valor == null)
        return false;
    return (!min || valor >= min) && (!max || valor <= max);
}
exports.busquedaRango = busquedaRango;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/filtros/rango.js
// module id = 2231
// module chunks = 0